import { Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { Color } from "../../theme/Color";

interface Props {
  showCloseIcon?: boolean;
  onClick: (boolean) => void;
}

const StyledHamburgerMenu = styled(Row)`
  flex-direction: column;
  align-items: end;
  width: 40px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  & span {
    background: ${Color.White};
    border-radius: 5px;
    height: 3px;
    margin: 3px 0;
    transition: 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6);
  }

  & span:nth-of-type(1) {
    width: 100%;
  }

  & span:nth-of-type(2) {
    text-align: right;
    width: 50%;
  }

  & span:nth-of-type(3) {
    width: 75%;
  }

  &.showCloseIcon span:nth-of-type(1) {
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
    transform: rotatez(45deg) translate(9px, 0px);
    -webkit-transform: rotatez(45deg) translate(9px, 0px);
  }

  &.showCloseIcon span:nth-of-type(2) {
    transform-origin: top;
    -webkit-transform-origin: top;
    transform: rotatez(-45deg) translate(9px, -4px);
    -webkit-transform: rotatez(-45deg) translate(9px, -4px);
  }

  &.showCloseIcon span:nth-of-type(3) {
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
    width: 50%;
    transform: translate(-9px, -4px) rotatez(-45deg);
    -webkit-transform: translate(-9px, -4px) rotatez(-45deg);
  }
`;

const HamburgerIcon = ({ showCloseIcon = false, onClick }: Props) => {
  return (
    <StyledHamburgerMenu
      className={showCloseIcon ? "showCloseIcon" : "showHamburgerIcon"}
      onClick={onClick}
    >
      <span></span>
      <span></span>
      <span></span>
    </StyledHamburgerMenu>
  );
};

export default HamburgerIcon;
